var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewRLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.2541 0H8.7459C3.91567 0 0 3.91567 0 8.7459V47.2541C0 52.0843 3.91567 56 8.7459 56H47.2541C52.0843 56 56 52.0843 56 47.2541V8.7459C56 3.91567 52.0843 0 47.2541 0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.4736 31.8758C44.9373 31.0695 45.2298 29.985 46.089 29.539C46.0945 29.5362 46.1 29.5335 46.1054 29.5302C47.3577 28.8759 48.3367 27.9614 49.0408 26.7873C49.7454 25.6137 50.098 24.2482 50.098 22.6915C50.098 21.1347 49.7508 19.7764 49.0577 18.6143C48.3641 17.4532 47.408 16.5387 46.1891 15.8713C44.9701 15.2044 43.5555 14.8705 41.9451 14.8705H31.0417C30.4399 14.8705 29.8878 15.205 29.609 15.7385C26.7677 21.3872 23.9258 27.0366 21.0845 32.6853C20.4444 33.9578 18.6209 33.936 18.0109 32.6487C17.1664 30.8651 16.3218 29.082 15.4773 27.2984C14.9853 26.3571 14.0113 25.7673 12.9492 25.7673H10.3926C9.41311 25.7673 8.78341 26.807 9.2371 27.675L14.8339 38.3849C15.7216 40.0838 17.4801 41.1492 19.3971 41.1492H19.5223C21.5163 41.1492 23.3448 40.0412 24.2686 38.2745L33.4698 20.6679C33.7486 20.1344 34.3007 19.7999 34.9025 19.7999H41.1061C42.09 19.7999 42.8449 20.0781 43.3702 20.634C43.8955 21.1899 44.1589 21.9125 44.1589 22.8024C44.1589 23.6923 43.8955 24.4396 43.3702 24.9709C42.8449 25.5027 42.09 25.7678 41.1061 25.7678H38.1489C36.8851 25.7678 36.11 27.1524 36.7708 28.2298L43.8572 39.7837C44.3776 40.6326 45.3019 41.1497 46.2979 41.1497C48.5833 41.1497 49.9471 38.6041 48.6817 36.7013L45.4725 31.8758H45.4736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.4749 14.8505H8.65558C7.11202 14.8505 5.86072 16.1018 5.86072 17.6454C5.86072 19.1889 7.11202 20.4402 8.65557 20.4402H21.4749C23.0184 20.4402 24.2697 19.1889 24.2697 17.6454C24.2697 16.1018 23.0184 14.8505 21.4749 14.8505Z",
    fill: "#50B786"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRLogoIcon);
export default __webpack_public_path__ + "static/media/view-r-logo-icon.e72346505451a98d2e492d138d931671.svg";
export { ForwardRef as ReactComponent };